import React from "react";
import { Link } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import Map from "./map.js";
import Hospital from "../../assets/Hospitals.png";
import Star from "../../assets/star.svg";
import Direction from "../../assets/direction.svg";

import {
  Container,
  Card,
  Content,
  Icons,
  ResultContainer,
  Loader,
  Empty,
} from "../../styles/search/hospitals";

const Hospitals = ({ hospitals, loading } = this.props) => {
  const list =
    hospitals?.length > 0 ? (
      hospitals.map((hospital) => {
        return (
          <Card key={hospital.place_id}>
            <Link to={`/hospital/${hospital.place_id}`} className="card">
              <Content>
                <h3>{hospital.name}</h3>
                <hr />
                <p>{hospital.formatted_address}</p>
                <Icons>
                  <img src={Star} alt="" />
                  <p>{hospital?.rating ? hospital.rating : "None"}</p>
                  <img src={Direction} alt="" />
                  <p>Get directions</p>
                </Icons>
              </Content>
            </Link>
            <img src={Hospital} alt="hospital" />
          </Card>
        );
      })
    ) : (
      <Empty hidden={loading}>Empty Result</Empty>
    );
  return (
    <Container>
      <ResultContainer>
        <div className="results">
          {list}
          <Loader hidden={!loading}>
            <Skeleton className="loader-item" height={150} />
            <Skeleton className="loader-item" height={150} />
            <Skeleton className="loader-item" height={150} />
          </Loader>
        </div>
        <Map />
      </ResultContainer>
    </Container>
  );
};

export default Hospitals;
